import moment from "moment"

// When a location counts as offline. One place for the rule, so the table, the location form,
// the "Offline" filter and the map always agree.

// A ping or a sync older than this (or missing) is a warning
export const STALE_AFTER_HOURS = 4
const STALE_AFTER_MS = STALE_AFTER_HOURS * 60 * 60 * 1000

// True when `value` (an ISO string or a timestamp in milliseconds) is missing, cannot be read,
// or is at least 4 hours old. A time in the future (a clock that is a bit off) is not stale.
export const isStale = (value, now = Date.now()) => {
  if (!value) return true
  const time = moment(value).valueOf()
  if (Number.isNaN(time)) return true
  return now - time >= STALE_AFTER_MS
}

// A location is offline when its last ping OR its last sync is stale
export const isOffline = (location, now = Date.now()) =>
  isStale(location?.lastPing, now) || isStale(location?.lastSync, now)

// "5 minutes ago", or "N/A" when there is no usable time
export const formatAgo = (value) => {
  if (!value) return "N/A"
  const parsed = moment(value)
  return parsed.isValid() ? parsed.fromNow() : "N/A"
}
